// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"fadd9aaa","87":"c257ebcd","115":"6b4f0c4f","233":"1092b099","286":"454c67df","297":"884ce3c9","300":"8af6d36f","328":"a362cdb8","416":"a18e60f2","569":"76acb80d","607":"40b00058","638":"8424c583","852":"0411c42a","988":"f18d1f20"}[chunkId] + ".chunk.js";
};